<template>
  <div>
    <div class="row sticky-button">
      <div class="col-12 col-sm-7 col-md-5 col-lg-5 px-0 mb-3">
        <div class="form-group has-label">
          <minus-plus
            :label="`${$t('common_words.sub_categories_num')}: *`"
            @handlePlus="handlePlus"
            @handleMinus="handleMinus"
            :value="model.subcategory_number"
          />
        </div>
      </div>
    </div>
    <div
      class="row py-3 mb-4 shadow-sm"
      style="border: 0.5px solid #6ba6524d"
      v-for="index in model.subcategory_number"
      :key="index"
    >
      <div class="col-12 col-sm-4 col-md-3 col-lg-2">
        <fg-input
          :label="`${$t('common_words.code')}: *`"
          class="required-code"
          ref="code"
          type="text"
          v-model="model.code_sub[index - 1]"
          name="common_words.code_of_row"
          v-validate="modelValidations.code_sub"
          :error="
            getError('common_words.code_of_row', true, {
              '%1%': index,
            })
          "
          placeholder="..."
          @click="handleClickOnCode(index - 1)"
        ></fg-input>
      </div>

      <div class="col-12 col-sm-8 col-md-9 col-lg-3">
        <fg-input
          :label="`${$t('common_words.sub_category_num')} ${index}: *`"
          class="required-name pl-0"
          ref="name"
          type="text"
          v-model="model.name_sub[index - 1]"
          name="common_words.sub_category_num_with_index"
          v-validate="modelValidations.name_sub"
          :error="
            getError('common_words.sub_category_num_with_index', true, {
              '%1%': index,
            })
          "
          placeholder="..."
        ></fg-input>
      </div>

      <div class="col-12 col-sm-9 col-md-10 col-lg-5">
        <fg-input
          :label="`${$t('common_words.description')}:`"
          class="required-description"
          v-model="model.description_sub[index - 1]"
          placeholder="..."
          maxlength="200"
          show-word-limit
          type="textarea"
        ></fg-input>
      </div>
      <div class="col-12 col-sm-3 col-md-1 col-lg-2">
        <div class="form-group has-label">
          <label>{{ $t('common_words.status') }}</label>
          <el-switch
            v-model="model.enable[index - 1]"
            style="display: block; margin-top: 0.5rem"
            active-color="#6BA652"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util';
import { MixinExport } from 'src/mixins/mixin-export';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: {
    [MinusPlus.name]: MinusPlus,
  },
  data() {
    return {
      model: {
        id_sub: [],
        name_sub: [],
        code_sub: [],
        description_sub: [],
        enable: [true],
        subcategory_number: 1,
      },
      modelValidations: {
        name_sub: {
          required: true,
        },
        code_sub: {
          required: true,
        },
        subcategory_number: {
          required: true,
          min_value: 0,
        },
      },
      enable: [],
      subcategoriesCode: [],
    };
  },
  mixins: [MixinPermissions, MixinExport, MixinForm],
  methods: {
    async handleClickOnCode(index) {
      if (!isset(this.model.code_sub[index])) {
        let tableCode = isset(this.subcategoriesCode)
          ? this.subcategoriesCode
          : sessionStorage.getItem('tableCode');

        if (isset(tableCode)) {
          tableCode =
            typeof tableCode === 'string'
              ? Object(JSON.parse(tableCode))
              : tableCode;

          tableCode =
            tableCode[0] && tableCode[0].subcategories_code
              ? tableCode[0].subcategories_code
              : tableCode;

          const code = await this.codeGenerator('S C', tableCode, null);
          this.subcategoriesCode.push(code);
          this.$set(this.model.code_sub, index, code);
        }
      }
    },
    handlePlus() {
      this.model.subcategory_number++;
      this.handleNumberChange();
    },
    handleMinus() {
      const minNumber = this.getNumberSubCategories() || 1;
      if (this.model.subcategory_number > minNumber) {
        this.model.subcategory_number--;
        this.handleNumberChange();
      }
    },
    getNumberSubCategories() {
      let value = this.model.id_sub.length;

      return value;
    },
    handleNumberChange() {
      let codes = [...this.model.code_sub];
      let names = [...this.model.name_sub];
      let descriptions = [...this.model.description_sub];
      let actEnables = Array.from(
        { length: this.model.subcategory_number },
        () => true
      );

      let codeToRemove = codes[this.model.subcategory_number];
      codeToRemove = [...this.subcategoriesCode].indexOf(codeToRemove);

      if (codeToRemove !== -1) {
        this.subcategoriesCode.splice(codeToRemove, 1);
      }

      this.model.enable = actEnables;
      this.$set(
        this.model,
        'code_sub',
        codes.splice(0, this.model.subcategory_number)
      );
      this.$set(
        this.model,
        'name_sub',
        names.splice(0, this.model.subcategory_number)
      );
      this.$set(
        this.model,
        'description_sub',
        descriptions.splice(0, this.model.subcategory_number)
      );
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', this.model);
        return res;
      });
    },
  },
  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      this.model.enable = [];
      const { subcategories_code, subcategories } = JSON.parse(
        sessionStorage.getItem('editForm')
      );
      this.subcategoriesCode = subcategories_code;
      this.model.subcategory_number = subcategories.length;

      subcategories.forEach(({ id, name, code, description, deleted_at }) => {
        this.model.id_sub.push(id);
        this.model.name_sub.push(name);
        this.model.code_sub.push(code);
        this.model.description_sub.push(description);

        if (deleted_at) {
          this.model.enable.push(false);
        } else {
          this.model.enable.push(true);
        }
      });
    }
  },
};
</script>
